export default __webpack_public_path__ + "static/media/ic-arrow-right-blue.68776146.svg";